<template>
  <div class="container-fluid p-0">
    <div class="home-header"></div>
    <div class="row home-body">
      <img
          :src="require('@/assets/logo.png')"
          alt="user icon"
        />
      <p class = 'col-12 text-center pl-3 pr-3'>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Deserunt ullam, eveniet minus ipsum excepturi nostrum placeat soluta fugiat! Necessitatibus eaque animi facilis voluptatem vel, voluptatum rem inventore illum! Sunt, nam?
      </p>
       <div class="col-12 mx-auto  mt-4">
        <router-link tag="button"  class="btn-home ml-auto mr-auto" to="/login" exact>
          ACCEDER
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  components: {
  },
  mounted () {
    this.$store.commit('set_view_name', ['Home'])
    this.$store.commit('set_view_role', [''])
  },
}
</script>

<style lang= "scss" scoped>

.home-header {
  /* max-width: 100%; */
  /* max-height: 200px; */
   min-height: 300px;
   background-image: url('~@/assets/background-login.png');
   background-size: cover;
   border-bottom: 6px solid $nav-background-mobile;
}

.home-body {
    position: relative;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    min-width: 300px;
    margin-left: auto;
    margin-right: auto; 

}


.home-body > img {
    height: auto;
    margin-top: 25px;
    margin-bottom: 25px;
    width: 100%;
    max-width: 150px;
    margin-left: auto;
    margin-right: auto; 
}

/* .card-login > img {
    max-width: 200px;
    width: 100%;
    height: auto;
    margin-left: auto;
    margin-right: auto;
} */

@supports(object-fit: cover){
    .home-body > img{
      height: 100%;
      object-fit: cover;
      object-position: center center;
    }
}


</style>
